module.exports = __webpack_public_path__ + "static/media/ibd_shoulder3.d532cd98.png";